

import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row, Card, Table } from "react-bootstrap";
import { FaTrash, FaEdit, FaPlus } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

import Confirm from "../../Confirm";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  TableBody,
  TableHeader,
  PaginationOptions,
} from "react-bs-datatable";
import AddGroupModal from "./AddGroupModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SparkApi from "../../../api/SparkApi";

const GroupView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [group, setGroup] = useState(location.state ? location.state : {});
  const [showAddGroupModal, setShowAddGroupModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [showHideModel, setShowHideModel] = useState(false);

  useEffect(() => {
    fetchGroup();
  }, []);

  const fetchGroup = () => {
    async function initGroup() {
       
      let result = await SparkApi.fetchGroupsById(group.id);
      if (result.success) {
        setGroup(result.records);
      } else {
        setGroup([]);
      }
    }
    initGroup();
  };

  const handleBack = () => {
    navigate("/groups");
  };

  const handleAddMember = () => {
    setShowAddGroupModal(true);
  };

  const deleteRecord = (row) => {
    setSelectedId(row);
    setShowHideModel(true);
  };

  const deleteGroupMember = async () => {
     
    try {
      const response = await SparkApi.deleteGroupMember(selectedId);
      if (response.success) {
        setShowHideModel(false);
        toast.success("Group Member deleted successfully.");
        fetchGroup();
      } else {
        setShowHideModel(false);
        toast.error(response.error.message);
      }
    } catch (error) {

    }
  };

  const header = [
    {
      title: "Member Name",
      prop: "full_name",
      isFilterable: true,
      cell: (row) => (
        <>{row.member_firstname} {row.member_lastname}</>
      ),
    },
    { title: "Country Code", prop: "country_code" },
    { title: "WhatsApp Number", prop: "whatsapp_number" },
    {
      title: "Actions",
      prop: "groupmemberid",
      cell: (row) => (
        <>
          {group.members?.length > 1 && (
            <Button className="btn-sm mx-2" variant="danger" onClick={() => deleteRecord(row.groupmemberid)}>
              Remove
            </Button>
          )}
        </>
      ),
    },
  ];

  const membersWithFullName = group.members?.map((member) => ({
    ...member,
    full_name: `${member.member_firstname} ${member.member_lastname}`,
  }));

  return (
    <>
      <Container className="mt-5 mb-5">
        <Row className="mx-5 mb-4">
          <Card className="p-4 bg-white shadow-sm border-0 rounded-3">
            <h5 className="mb-2 fw-bold">💡 Quick Guide</h5>
            <small>
              Group members are individuals added to a shared chat group for better communication.

            </small>
          </Card>
        </Row>

        <Row className="mx-5 g-0">
          <Col lg={12} className="mb-3">
            <Row className="g-0">
              <Col lg={12}>
                <div className="bg-white shadow-sm border-0 rounded-3 p-4">
                  <h5 className="fw-semibold mb-1">📦 All Members</h5>
                  {group.members && (
                    <DatatableWrapper
                      body={membersWithFullName}
                      headers={header}
                      paginationOptionsProps={{
                        initialState: {
                          rowsPerPage: 10,
                          options: [5, 10, 15, 20],
                        },
                      }}
                    >
                      <Row className="mb-3">
                        <Col lg={3} sm={10} xs={10} className="d-flex flex-col justify-content-end align-items-end">
                          <Filter className="p-2" />
                        </Col>
                        <Col lg={4} sm={2} xs={2} className="d-flex flex-col justify-content-start align-items-start">
                          <PaginationOptions labels={{ beforeSelect: "Rows per page" }} />
                        </Col>
                        <Col lg={5} sm={12} xs={12} className="mt-2 d-flex flex-col justify-content-end align-items-end">
                          <Button className="btn btn-sm" variant="outline-secondary" onClick={handleAddMember}>
                            <FaPlus /> Add More Members
                          </Button>
                        </Col>
                      </Row>

                      <div className="table-responsive">
                        <Table striped bordered className="related-list-table" responsive="sm">
                          <TableHeader />
                          <TableBody />
                        </Table>
                      </div>
                      <Pagination />
                    </DatatableWrapper>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {showHideModel && (
        <Confirm
          show={showHideModel}
          onHide={() => setShowHideModel(false)}
          deleteGroupMember={deleteGroupMember}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="group_member"
        />
      )}

      {showAddGroupModal && (
        <AddGroupModal
          show={showAddGroupModal}
          onHide={() => setShowAddGroupModal(false)}
          fetchGroupRecords={fetchGroup}
          selectedGroup={group}
        />
      )}

      <ToastContainer />
    </>
  );
};

export default GroupView;